// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nul[data-v-6d3ff6e6] {\n  list-style: none;\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\nli[data-v-6d3ff6e6] {\n  display: table-row;\n}\nb[data-v-6d3ff6e6] {\n  display: table-cell;\n  width: 150px;\n}\nspan[data-v-6d3ff6e6] {\n  display: table-cell;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
